import { Form, Input } from "antd";
import { FIELD_TYPE } from "types/enums";
import { ColumnsEdit } from "types/models/column-table-edit";
import { DataFormField } from "types/models/input-field-type";
import React from "react";
import { formatToCurrencyType } from "helper/common";
import { listOptionMat } from "pages/Examination/components/InforDetail/DetailTabInfo/components/ConcludePrecription/ConcludeIcd/ConcludeIcd.config";

const { INPUT } = FIELD_TYPE;

const validatePositiveInteger = (_, value) => {
  if (!value || /^[1-9]\d*$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject(new Error("Chưa nhập đúng định dạng!"));
};

const cssProps = {
  css: { xl: 24, md: 24, xs: 24 },
  labelCol: { xl: 4, lg: 6 },
  wrapperCol: { xl: 20, lg: 18 },
};
const fields: DataFormField[] = [
  {
    type: INPUT,
    name: "ketLuanBacSy",
    label: "Chẩn đoán khác",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
    disable: true,
  },
];

const fields2: DataFormField[] = [
  {
    type: INPUT,
    name: "taiKham",
    label: "Ghi chú",
    css: cssProps.css,
    labelCol: cssProps.labelCol,
    wrapperCol: cssProps.wrapperCol,
    disable: true,
  },
];

const columns: ColumnsEdit = [
  {
    key: "stt",
    dataIndex: "stt",
    title: "STT",
    render: (t, r, i) => i + 1,
    width: 20,
    fixed: "left",
    align: "center",
  },
  {
    key: "maIcd",
    dataIndex: "maIcd",
    title: "Mã ICD",
    align: "left",
    width: 100,
  },
  {
    key: "tenIcd",
    dataIndex: "tenIcd",
    title: "Tên ICD",
    align: "left",
    width: 150,
  },
  {
    key: "mat",
    dataIndex: "mat",
    title: "Mắt",
    align: "left",
    width: 150,
    render: (v) => (v ? listOptionMat.find((e) => e.value === v)?.label : ""),
  },
  {
    key: "ghiChu",
    dataIndex: "ghiChu",
    title: "Ghi chú",
    align: "left",
    width: 200,
  },
];

const columnsTableMenu: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    render: (v, r, i) => i + 1,
    width: 50,
    fixed: "left",
  },
  {
    key: 1,
    dataIndex: "idThuoc",
    title: "Mã thuốc",
    align: "center",
    selected: true,
    width: 80,
  },
  {
    key: 2,
    dataIndex: "tenThuoc",
    title: "Tên thuốc",
    align: "left",
    editable: true,
    type: "AUTO_COMPLETE",
    width: 150,
  },
  {
    key: 3,
    title: "Đơn vị",
    dataIndex: "donVi",
    selected: true,
    width: 100,
  },
  {
    key: 4,
    title: "Số lượng",
    dataIndex: "soLuong",
    editable: true,
    type: "INPUT",
    rules: [{ validator: validatePositiveInteger }],
    width: 100,
    align: "right",
  },
  {
    key: 5,
    title: "Đơn giá bán",
    dataIndex: "donGiaBan",
    disabled: true,
    type: "INPUT",
    width: 100,
    render: (v) => formatToCurrencyType(v),
    align: "right",
  },

  {
    key: 7,
    title: "Hoạt chất",
    dataIndex: "hoatChat",
    editable: true,
    type: "AUTO_COMPLETE",
    width: 100,
  },
  {
    key: 8,
    title: "Nồng độ/hàm lượng",
    dataIndex: "nongDo",
    editable: true,
    type: "INPUT",
    width: 150,
  },
  {
    key: 9,
    title: "Liều dùng",
    dataIndex: "lieuDung",
    editable: true,
    type: "INPUT",
    width: 100,
  },
  {
    key: 10,
    title: "Ghi chú của BS",
    dataIndex: "ghiChu",
    editable: true,
    type: "INPUT",
    width: 200,
  },
];

export { columns, fields, fields2, columnsTableMenu };
